import type { RouteObject } from "react-router-dom";
import AppLayout from "@/components/feature/AppLayout";
import Home from "@/pages/home/page";
import Episodes from "@/pages/episodes/page";
import EpisodeDetail from "@/pages/episode-detail/page";
import Characters from "@/pages/characters/page";
import CharacterDetail from "@/pages/character-detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news-detail/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "episodes", element: <Episodes /> },
      { path: "episode/:id", element: <EpisodeDetail /> },
      { path: "characters", element: <Characters /> },
      { path: "character/:id", element: <CharacterDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;